<template>
  <bdg-input-template
    :name="name"
    :required="required"
    :invalid="isInvalid"
    @focusout="onFocusout"
  >
    <input
      class="w-full"
      :class="{ invalid: isInvalid }"
      type="number"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      v-model="inputVal"
    />
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";

export default {
  name: "BdgNumberField",
  extends: BdgInputTemplate,
  components: { BdgInputTemplate },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    value: [String, Number],
    forceInt: Boolean
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isValid() {
      return !isNaN(parseFloat(this.inputVal)) && !isNaN(this.inputVal - 0);
    }
  },
  methods: {
    onFocusout() {
      if (this.forceInt && this.inputVal) {
        this.inputVal = Math.round(this.inputVal);
      }
      this.isInvalid = this.required && !this.isValid;
    }
  }
};
</script>

<style scoped></style>
